import { required } from "@vuelidate/validators";

export default class Calendar {
  constructor(date,initTime,endTime) {
    this.id = null;
    this.date = date;
    this.initTime = initTime;
    this.endTime = endTime;
  }
  validations() {
    return {
      date: {
        required,
      },
      initTime: {
        required,
      },
      endTime: {
        required,
      },
    };
  }
}
